export const BRAND_PLP_FEATURE_NAME = 'brand-plp';
